import React, { useState } from "react";
import "./style.scss";
import Storelist from "../../Store/Actions";
import Api from "../../Utils/Api";
import { FaChevronUp, FaChevronDown } from "react-icons/fa";
import ServiceCard from "../ServiceCard";

const CategoryList = () => {
  const {
    RequestsStore,
    setLoading,
    clearCreateRequestData_,
    setCreatemodal_,
    ServiceDetailsStore,
  } = Storelist();
  const { GetRequestByID, _Post_MobileNumber } = Api();
  const [Searchvalue, setSearchvalue] = useState("");
  const [show, setShow] = useState({
    HomeService: false,
    Pickupbycustomer: false,
    JBCDrop: false,
    Yettoconfirm: false,
  });
  let Data = RequestsStore?.list;
  const serviceDetail = ServiceDetailsStore?.data;
  const TaskHandler = (id) => {
    if (serviceDetail?.bikeRequest?._id === id) return;
    clearCreateRequestData_();
    _Post_MobileNumber.setData(null);
    setCreatemodal_(false);
    setLoading(true);
    console.log('ertyuiop[');
    GetRequestByID(id);
  };

  return (
    <div className="actions-menu-container">
      <div className="search-container">
        <label htmlFor="search">
          <i className="fa-solid fa-magnifying-glass"></i>
        </label>
        <input
          type="search"
          value={Searchvalue}
          name="search"
          onInput={(e) => setSearchvalue(e.target.value)}
          id="search"
          placeholder="search"
        />
      </div>
      <div className="action-header">
        <span style={{ backgroundColor: `var(--request)` }}></span>
        <p>New Requests ({Data?.newRequestDetails?.count})</p>
        <p>
          <i className="fa-solid fa-chart-line"></i>
        </p>
      </div>
      <div className="scrollable-div">
        {Data?.newRequestDetails?.requestDetails?.map((item, index) => {
          if (
            item?.customerName
              ?.toLowerCase()
              ?.includes(Searchvalue?.toLowerCase())
          )
            return (
              <div key={index}>
                <ServiceCard
                  data={item}
                  TaskHandler={TaskHandler}
                ></ServiceCard>
              </div>
            );
        })}
      </div>
      <div className="action-header">
        <span style={{ backgroundColor: `var(--A-request)` }}></span>
        <p>Assigned Requests ({Data?.acceptedRequestDetails?.count})</p>
        <p>
          <i className="fa-solid fa-chart-line"></i>
        </p>
      </div>
      <div className="scrollable-div">
        {Data?.acceptedRequestDetails?.requestDetails?.map((item, index) => {
          if (
            item?.customerName
              ?.toLowerCase()
              ?.includes(Searchvalue?.toLowerCase())
          )
            return (
              <div key={index}>
                <ServiceCard
                  data={item}
                  TaskHandler={TaskHandler}
                ></ServiceCard>
              </div>
            );
        })}
      </div>
      <div className="action-header">
        <span style={{ backgroundColor: `var(--service)` }}></span>
        <p>In Service ({Data?.inServiceRequestDetails?.count})</p>
        <p>
          <i className="fa-solid fa-chart-line"></i>
        </p>
      </div>
      <div className="scrollable-div">
        {Data?.inServiceRequestDetails?.requestDetails?.map((item, index) => {
          return (
            <div key={index}>
              <ServiceCard data={item} TaskHandler={TaskHandler}></ServiceCard>
            </div>
          );
        })}
      </div>
      <div className="action-header">
        <span style={{ backgroundColor: `var(--R-delivery)` }}></span>
        <p>
          Ready for Delivery ({Data?.readyForDeliveryRequestDetails?.count})
        </p>
        <p>
          <i className="fa-solid fa-chart-line"></i>
        </p>
      </div>
      <div className="scrollable-div">
        <div className="Sub-menu flex justify-start relative">
          <span className="text-start ">
            Home Service(
            {Data?.readyForDeliveryRequestDetails?.homeService?.length})
          </span>{" "}
          <span
            className="chevron-close absolute right-1 top-0.5"
            onClick={() => {
              setShow((prev) => ({ ...prev, HomeService: !prev.HomeService }));
            }}
          >
            {show?.HomeService ? <FaChevronUp /> : <FaChevronDown />}
          </span>
        </div>
        {show.HomeService &&
          Data?.readyForDeliveryRequestDetails?.homeService?.map(
            (item, index) => {
              return (
                <div key={index}>
                  <ServiceCard
                    data={item}
                    TaskHandler={TaskHandler}
                  ></ServiceCard>
                </div>
              );
            }
          )}
        <div className="Sub-menu flex justify-start relative">
          <span className="text-start">
            Yet To Pick up - By Customer (
            {Data?.readyForDeliveryRequestDetails?.pickUpByCustomer?.length})
          </span>
          <span
            className="chevron-close absolute right-1 top-0.5"
            onClick={() => {
              setShow((prev) => ({
                ...prev,
                Pickupbycustomer: !prev.Pickupbycustomer,
              }));
            }}
          >
            {show?.Pickupbycustomer ? <FaChevronUp /> : <FaChevronDown />}
          </span>
        </div>
        {show?.Pickupbycustomer &&
          Data?.readyForDeliveryRequestDetails?.pickUpByCustomer?.map(
            (item, index) => {
              return (
                <div key={index}>
                  <ServiceCard
                    data={item}
                    TaskHandler={TaskHandler}
                  ></ServiceCard>
                </div>
              );
            }
          )}
        <div className="Sub-menu flex justify-start relative">
          <span className="">
            Yet To Deliver - By JBC(
            {Data?.readyForDeliveryRequestDetails?.deliverByJBC?.length}
          </span>
          <span
            className="chevron-close absolute right-1 top-0.5"
            onClick={() => {
              setShow((prev) => ({
                ...prev,
                JBCDrop: !prev.JBCDrop,
              }));
            }}
          >
            {show?.JBCDrop ? <FaChevronUp /> : <FaChevronDown />}
          </span>
          )
        </div>
        {show?.JBCDrop &&
          Data?.readyForDeliveryRequestDetails?.deliverByJBC?.map(
            (item, index) => {
              return (
                <div key={index}>
                  <ServiceCard
                    data={item}
                    TaskHandler={TaskHandler}
                  ></ServiceCard>
                </div>
              );
            }
          )}
      </div>
      <div className="action-header">
        <span style={{ backgroundColor: `var(--delivered)` }}></span>
        <p>Delivered ({Data?.deliveredRequestDetails?.count})</p>
        <p>
          <i className="fa-solid fa-chart-line"></i>
        </p>
      </div>
      <div className="scrollable-div">
        {Data?.deliveredRequestDetails?.requestDetails?.map((item, index) => {
          return (
            <div key={index}>
              <ServiceCard data={item} TaskHandler={TaskHandler}></ServiceCard>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default CategoryList;
